<template>
  <b-modal
    :id="id"
    v-model="onboardModel"
    hide-header
    hide-footer
    no-stacking
    :no-close-on-backdrop="noCloseOnBackdrop"
    centered
    body-class="p-0"
  >
    <b-card
        :title="welcomeTitle"
        :sub-title="welcomeMessageInfo"
        img-src="@/assets/img/onboarding/grandsmaanddaugther.png"
        img-alt="Image"
        img-top
        tag="article"
        style="width: 100%; height: 100%"
    >
      <b-link
          @click="handleDismissClickWithType('ok')"
          class="float-right"
          style="box-shadow: none"
          variant="primary">
        Ok, got it
      </b-link>
    </b-card>
  </b-modal>
</template>

<script>
import EventLog from "@/mixins/resourceBlocks/EventLog";
export default {
  name: "Modal_OnBoardWelcome",
  mixins: [EventLog],
  components: {},
  props: {
    id: {
      type: String,
      required: true
    },
    onboardModel: {
      type: Boolean,
      default: false
    },
    profile: {
      type: Object,
      default: () => {}
    },
    noCloseOnBackdrop: {
      //Determines whether the app can close with outside click- can still track dat
      type: Boolean,
      default: true
    }
  },
  computed: {},
  methods: {
    handleDismissClickWithType(dismissType) {
      this.$bvModal.hide(this.id);
      this.$emit('start-click');
    }
  },
  data() {
    return {
      form:{},
      welcomeTitle: `Hi ${this.profile ?  this.profile.firstname : 'Family'},`,
      welcomeMessageInfo:"Welcome to D3rriana, your trusted companion on your caregiving journey. We understand the unique challenges and joys that come with caring for a loved one, and we're here to make that journey more fulfilling.",
      welcomeMessage: "Good news! Your family will receive a 14-day free trial of our solid plan which includes:",
      viewHeight: 250,
      /** SLIDE **/
      slideId: "aboutIntroSlides",
      interval: 0,
      controls: false,
      indicators: false,
      slide: 0,
      sliding: null,
      selectedPolicyURLPath: "/policy/terms",
      /** IMG **/
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      },
      contactEmail: "help@ponyengine.com",
      contactPhone: "help@ponyengine.com"
    };
  }
};
</script>

<style lang="scss" scoped>
.modal-backdrop {
  z-index: 1040 !important;
}
.modal-content {
  margin: 2px auto;
  z-index: 1100 !important;
}

.success-body {
  position: relative;
  .close-ico {
    position: absolute;
    top: 0px;
    right: 0px;
    cursor: pointer;
  }
  .ballon-img {
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translate(-50%, -100%);
  }
  h3 {
    padding-top: 40px;
    font-weight: bold;
    font-size: 40px;
    line-height: 55px;
    color: #0a111a;
    text-align: center;
    margin-bottom: 0;
    cursor: pointer;
  }
  .main {
    margin-top: 22px;
    font-weight: normal;
    font-size: 20px;
    line-height: 33px;
    text-align: center;
    color: #52595e;

    .position {
      height: 37px;
      background: #65ea82;
      box-shadow: 0px 4px 16px rgba(101, 234, 130, 0.4);
      border-radius: 32px;
      //display: flex;
      //justify-content: center;
      //align-items: center;
      padding: 0 10px;
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      text-align: center;
      color: #ffffff;
    }
  }
  .policies {
    margin-top: 13px;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 33px;
    text-align: center;
    color: #52595e;
  }
  .action-btns {
    margin-top: 13px;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 33px;
    color: #52595e;
  }
  .send-list {
    margin-top: 22px;
    font-style: italic;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #52595e;
    padding-bottom: 36px;
  }
  .policies :hover {
    box-shadow: none;
  }
  .action-btns :hover {
    box-shadow: none;
  }
}
</style>
